/**
 * Created by sswaminathan on 1/27/22
 * File: RegionDropDown
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { groupBy, keyBy } from 'lodash'
import { APP_ID_LOGGING_SERVICE, APP_ID_PAN_CHINA } from '../constants/GlobalConstants'
import { APP_ID_TO_NAME } from '../constants/LabelConstants'
import { FF_ENABLE_APP_LEVEL_REGION } from '../utils/FeatureFlags'
import { getVarValue } from '../utils/Sparky'
import { isNonemptyArray } from '../utils/Utils'
/**
 *   TODO: Brief what is this component/class do
 */


const RegionDropDown = (appIdList, appDefs, header, support_account_id = '') => {
  const enableAppLevelRegion = getVarValue(FF_ENABLE_APP_LEVEL_REGION, false)
  const regionDropDown = []
  const regionMap = keyBy(appDefs, 'app_id')
  // this is for reading region value to display name
  const platformRegionMap = regionMap['platform']?.regions
  const appRegionMaps = getAppProviderRegions(appIdList, regionMap, support_account_id)
  const appRegionKeys = Object.keys(appRegionMaps)
  // start from the platform Region manifest
  platformRegionMap?.forEach(({ name, display }) => {
    let includeRegion = true
    appRegionKeys.forEach((element) => {
      // handle global region
      if (!appRegionMaps[element].includes(name) && !appRegionMaps[element].includes('global')) {
        includeRegion = false
      }
    })
    if (includeRegion) {
      const regionObject = {
        'value': display,
        'description': name,
        'id': name
      }
      regionDropDown.push(regionObject)
    }
  })
  enableAppLevelRegion && updateAppBasedRegion(regionDropDown, appIdList, regionMap, support_account_id)
  if (header) {
    const regionSelect = {
      'value': 'Select a Region',
      'description': 'Select a Region',
      'id': ''
    }
    regionDropDown.unshift(regionSelect)
  }
  return regionDropDown
}
const getAppProviderRegions = ((appIdList, regionMap, support_account_id) => {
  const result = {}
  appIdList?.forEach((each) => {
    let appRegionList = regionMap[each]?.regions ?? false
    if (!appRegionList) {
      return
    }
    // To check if the China SKu is available
    const isChinaRegionAvailable = appRegionList.some(({ name }) => name === 'cn')
    if (isChinaRegionAvailable && !appIdList.includes(APP_ID_PAN_CHINA)) {
      appRegionList = appRegionList.filter((elem) => elem.name !== 'cn')
    }
    const regions = []
    appRegionList.forEach((element) => {
      const filteredAccount = []
      // To apply restricted accounts on the platform region level
      if (element?.platform_region_extra) {
        const keys = Object.keys(element?.platform_region_extra)
        keys.forEach((regionKey) => {
          const restricted_region = element?.platform_region_extra[regionKey].restricted_accounts
          if (restricted_region && !restricted_region.includes(+support_account_id)) {
            filteredAccount.push(regionKey)
          }
        })
      }
      if (element.supported_types?.federal) {
        return
      }
      if (element.platform_regions) {
        regions.push(...(element.platform_regions.filter((each) => !filteredAccount.includes(each))))
      }
      else if (element.logging_service_region) {
        regions.push(element.logging_service_region)
      }
      else if (element.name === 'global') {
        regions.push('global')
      }
    })
    result[each] = regions
  }
  )
  return result
})

/**
 *  This method will add the additional regions based on the app_ids
 * @type {updateAppBasedRegion}
 */
const updateAppBasedRegion = ((regionDropDown, appIdList, regionMap, support_account_id) => {
  if (isNonemptyArray(regionDropDown)) {
    /**
     *  Iterate through each region in the dropdrown
     * For each app in the license check if there is any multiple region associated with it. IF there is any
     * restricted account present in the region, only for that restricted CSP add the additional region mapping
     */
    regionDropDown.forEach((region) => {
      appIdList.forEach((each) => {
        const appRegionList = regionMap[each]?.regions ?? false
        if (appRegionList && each !== APP_ID_LOGGING_SERVICE) {
          const multipleRegionList = []
          appRegionList.forEach((appRegion) => {
            if (appRegion.platform_regions?.includes(region.id)) {
              if (appRegion.restricted_accounts && appRegion.restricted_accounts.includes(+support_account_id)) {
                multipleRegionList.push({
                  'value': appRegion.display,
                  'description': appRegion.name,
                  'id': appRegion.name
                })
              }
              else if (!appRegion.restricted_accounts) {
                multipleRegionList.push({
                  'value': appRegion.display,
                  'description': appRegion.name,
                  'id': appRegion.name
                })
              }
            }
          })
          const groupByRegionName = groupBy(multipleRegionList, 'id')
          const regionKey = Object.keys(groupByRegionName)
          if (isNonemptyArray(multipleRegionList) && regionKey.length > 1) {
            multipleRegionList.unshift({
              'value': `Select A ${APP_ID_TO_NAME[each]} Region`,
              'description': `Select A ${APP_ID_TO_NAME[each]} Region`,
              'id': ''
            })
            if (!region.additional_region_mapping) {
              region.additional_region_mapping = {
                [each]: multipleRegionList
              }
            }
            else {
              region.additional_region_mapping[each] = multipleRegionList
            }
          }
        }
      })
    })
  }
})

RegionDropDown.propTypes = {}
export default RegionDropDown
